import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api";
import Loader from "../../common/loader";
import CreateRole from "./popups/createRole";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const Roles = ({ data }) => {
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [createRoleModal, setCreateRoleModal] = useState(false);
  const [render, setRender] = useState(false);   
  const [popupType, setPopupType] = useState('CREATE');   
  const [roleId, setRoleId] = useState('');   
  const [roleName, setRoleName] = useState('');
  const createRoleModalClose=()=>{setCreateRoleModal(false)} 
  const navigate = useNavigate();
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/roles/getRolesReport`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "role_id" },
        { data: "role" },
        { data: "active" },
        { 
          data: null,
          title: 'Actions',
          render:  (data, type, row) => (
            `<div> 
            <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
            <span class="a-delete"><i class="bi bi-trash-fill"></i></span>          
            </div>`
          )
            },
      ],
      createdRow: (row, data, dataIndex) => {  
        if(!checkPermissions('role_edit')){
          $(row).find('.a-edit').remove();
        }
        if(!checkPermissions('role_delete')){
          $(row).find('.a-delete').remove();
        }
        $(row).find('.a-edit').on('click', () => {
          setRoleId(data.role_id)
          setRoleName(data.role) 
          setCreateRoleModal(true); setPopupType('EDIT') } ); 
        $(row).find('.a-delete').on('click', () => {console.log(data)} );
      },
      'columnDefs': [ {
        'targets': [3], /* column index */
        'orderable': false, /* true or false */
     }],
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]],
    });
    // setIsLoading(false)
    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,render]);

    useEffect(() => {
    if(!checkPermissions('role_page') || !checkPermissions('settings_navigation')){ 
        navigate('/')
      }
    },[])
  const reRender=()=>{
    setRender(!render)
  }
  return (  
    <div> 
    <main id="main" className="main">
    <div className="pagetitle">
    <h1>Roles</h1> 
    </div>
    <section className="section">
        <div className="row">
          <div className="col-lg-12">
          <div className="card p-10">
          <h5 className="card-title">
              {checkPermissions('role_create') &&   <button type="button" className="btn btn-primary float-right"
                    onClick={()=>{setCreateRoleModal(true);setPopupType('CREATE');}}>
                    + Add Role
                  </button> }  
                </h5>
          {isLoading?<Loader />:"" } 
              <div className={isLoading?'card-body hide':'card-body'} >  
                 <table
                 className="table table-striped table-hover table-bordered no-footer dataTable"
                 width="100%"
                 ref={tableRef}
               >
                 <thead>
                 <tr>
                 <th>Role Id</th>
                 <th>Role</th>
                 <th>Active</th> 
                 <th>Action</th> 
                 </tr>
             </thead> 
              </table> 
              </div>
            </div> 
            </div>
        </div>
      </section>
  </main>  
  {createRoleModal && <CreateRole 
  isShow={createRoleModal} 
  close={createRoleModalClose}
  reRender={reRender}
  popupType={popupType}
  id={roleId}
  roleName={roleName}
    />} 
  </div>
  );
};
export default Roles;
 
    